import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AuthAPI, { CDN_URL, DEBUG } from '../AuthAPI';
import { useValidator } from '@arema/components/Hooks';
import { Button, Header, Icon, Input, Message } from 'react-frontier';
import { useAuth } from '../AuthHooks';
import { SetLoading } from '@arema/components/Classes';
import { Link, useLocation } from 'react-router-dom';

var ChangePasswordMessage = (props: { email: string, admin?: boolean, expired?: boolean })=>{
	return (
		<Message style={{ marginBottom: 15 }} type="info" text={`${props.expired ? 'La contraseña de AREMA de esta cuenta ha sido marcada como expirada.' : ''} Favor de ingresar una nueva contraseña`} list={[
			`Usuario: ${props.email}`,
			props.admin ? (
				'Por seguridad, la contraseña debe de ser de mínimo 8 caracteres y debe de tener por lo menos: 1 número, 1 letra mayúscula, 1 letra minúscula y 1 caracter especial (!@#$%^&*.,+).'
			) : (
				'La contraseña debe de ser de mínimo 8 caracteres'
			)
		]} />
	)
}

interface UserData{
	used: boolean,
	user_id: number,
	admin: boolean,
	email: string,
}

var RecoverPassword = ()=>{
	var { t } = useTranslation();
	var { params } = useAuth();
	var { search } = useLocation();
	var [user, setUser] = useState<UserData>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var form = useValidator({
		password: '',
		repeat_password: '',
	}, {
		password: [{ rule: 'email', prompt: t('create.prompts.password') }],
		repeat_password: [{ rule: 'matches', params: ['password'], prompt: t('create.prompts.repeat') }]
	});
	
	useEffect(()=>{
		if(!params.recover_token || params.recover_token.length<10) return;
		AuthAPI.verifyToken(params.recover_token).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setUser(res.data);
		}).catch(err=>{
			return setLoadError(t('common.unexpected_code', { code: 'LCL-ATHRC-1' }));
		});
	}, [params.recover_token]);

	var valid_token = useMemo(()=>{
		return !!params.recover_token && params.recover_token.length>10;
	}, [params?.recover_token]);

	var sendForgot = (setLoading: SetLoading)=>{
		var { valid } = form.validate(null, {
			password: [{ 
				rule: DEBUG ? 'length' : (!!user.admin ? 'password' : 'length'),
				params: [8, 127], 
				prompt: t('recover.prompts.secure_password')
			}],
		});
		if(!valid) return;
		setLoading(true);
		AuthAPI.recoverPassword(params.recover_token, form.data.password).then(res=>{
			if(res.error) return form.setPrompts([res.message]);
			setUser({
				...user,
				used: true,
			})
		}).catch(err=>{
			return form.setPrompts([t('common.unexpected_code', { code: 'LCL-ATHRC-2' })])
		}).finally(()=>{
			setLoading(false);
		})
	}
	
	return <div className="ar login-screen">
		<div className="contents">
			<img className='ar logo' src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" />
			<div className="title">
				{t('recover.title')}
			</div>
			<div className="subtitle">
				{t('recover.subtitle')}
			</div>
			{(!valid_token || !!loadError) ? (
				<div className="complete" style={{ marginTop: 10 }}>
					<Icon name='times-circle' color='brown' />
					<div className="title">
						{t(loadError ? 'common.error' : 'recover.invalid_title')}
					</div>
					<div className="subtitle">
						{loadError || t('recover.invalid_subtitle')}
					</div>
				</div>
			) : !user ? (
				<div className="complete small" style={{ marginTop: 10 }}>
					<Header loading text={t('common.loading')} subtext={t('recover.loading')} style={{ paddingTop: 0, margin: 0 }} />
				</div>
			) : user.used ? (
				<div className="complete" style={{ marginTop: 10 }}>
					<Icon name='circle-check' color='green' />
					<div className="title">
						{t('recover.used_title')}
					</div>
					<div className="subtitle">
						{t(user.user_id ? 'recover.used_subtitle' : 'recover.already_used')}
					</div>
					<Button text={t('common.login')} color='black' style={{ marginTop: 10 }} as={Link} to={`/`} />
				</div>
			) : (
				<div className="form">
					<ChangePasswordMessage admin={user.admin} email={user.email} />
					<Input label='Nueva contraseña' error={form.errors.password} value={form.data.password} onChange={form.onDataChange('password')} inputType='password' />
					<Input label='Repetir nueva contraseña' error={form.errors.repeat_password} value={form.data.repeat_password} onChange={form.onDataChange('repeat_password')} inputType='password' />
					<Message type='error' list={form.prompts} style={{ marginBottom: 15 }} />
					<div className="actions">
						<Button color='black' text={t('common.send')} onClick={sendForgot} />
					</div>
				</div>
			)}
		</div>	
	</div>
}

export default RecoverPassword;